import { Sparkles, Target, Zap, Lock, TrendingUp, Users } from "lucide-react";

const FEATURES = [
  {
    icon: Sparkles,
    title: "Multi-platform matching",
    desc: "Instagram, TikTok, YouTube, X. We verify handles across every platform — not just the one they mention at checkout.",
  },
  {
    icon: Target,
    title: "Influence scoring",
    desc: "A 0-100 score blending follower count, engagement rate, niche relevance, and purchase history. Sort the whales from the bots.",
  },
  {
    icon: Zap,
    title: "Klaviyo, Mailchimp & Gorgias sync",
    desc: "Push a 'Creator' tag to your existing CRM or helpdesk. Trigger segmented flows the moment a verified creator joins your list.",
  },
  {
    icon: Users,
    title: "Lookalike discovery",
    desc: "Found a creator you love? We surface their followers who also bought from you. Compound your reach, quietly.",
  },
  {
    icon: TrendingUp,
    title: "UTM tracking per creator",
    desc: "Auto-generated discount codes and tracked links. See which customers drive the most downstream revenue — even without a formal program.",
  },
  {
    icon: Lock,
    title: "Platform-native privacy",
    desc: "GDPR & CCPA compliant. We use the same customer data you already own through your store's official API. No scraping, no shady lists, no legal grey area.",
  },
];

export default function Features() {
  return (
    <section
      id="features"
      data-testid="features-section"
      className="relative py-24 md:py-32 bg-[#09090B]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <p className="text-[11px] tracking-[0.3em] uppercase text-[#D4FF00] font-semibold">
            Features
          </p>
          <h2 className="font-display uppercase text-5xl sm:text-6xl lg:text-7xl mt-4">
            Not a creator <br />
            marketplace. <br />
            <span className="outline-text">A detector.</span>
          </h2>
          <p className="mt-6 text-base md:text-lg text-[#A1A1AA] max-w-xl leading-relaxed">
            Everything you need to find, score, and reach the influencers
            already spending money with you.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5 border border-white/5">
          {FEATURES.map((f) => (
            <div
              key={f.title}
              data-testid={`feature-${f.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="group relative bg-[#09090B] p-8 hover:bg-[#0E0E10] transition-colors duration-300"
            >
              <div className="w-10 h-10 flex items-center justify-center border border-white/10 rounded-sm group-hover:border-[#D4FF00] group-hover:bg-[#D4FF00] transition-all duration-300">
                <f.icon className="w-5 h-5 text-white group-hover:text-black transition-colors duration-300" strokeWidth={1.6} />
              </div>
              <h3 className="mt-6 font-display uppercase text-xl tracking-tight">
                {f.title}
              </h3>
              <p className="mt-3 text-sm text-[#A1A1AA] leading-relaxed">
                {f.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
